import React from 'react'

import { Paper, Typography } from '@material-ui/core'
import styled from 'styled-components'

const ListedVideos = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  flex: 1 1 300px;
`
const ListedVideosContainer = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
`

const VideoItem = ({ video, onVideoSelect }) => {
  return (
    <ListedVideos>
      <ListedVideosContainer>
        <Paper elevation={5} style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', margin: '0 20px' }} onClick={() => onVideoSelect(video)}>
          <img style={{ width: '100%' }} alt='thumbnail' src={video.snippet.thumbnails.high.url} />
          <Typography variant='subtitle1' style={{ padding: '10px' }}><b>{video.snippet.title}</b></Typography>
        </Paper>
      </ListedVideosContainer>
    </ListedVideos>
  )
}

export default VideoItem
